import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

/** Page title row — vervangt `.page-actions` + `.page__lead`. */
export function PageHeader({
  title,
  lead,
  actions,
  meta,
  className,
}: {
  title: ReactNode;
  /** Max 60ch per *Basis layout*. */
  lead?: ReactNode;
  actions?: ReactNode;
  /** Small meta line under the title (badges, "created …"). */
  meta?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('mb-6 flex flex-wrap items-start justify-between gap-4', className)}>
      <div className="max-w-[60ch]">
        <h1 className="font-heading text-ink text-[28px] leading-9 font-semibold">{title}</h1>
        {lead && <p className="text-ink mt-1 text-[15px]">{lead}</p>}
        {meta && <div className="text-accent mt-2 flex items-center gap-2 text-sm">{meta}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
    </div>
  );
}
